/*
 * @Author: fengjiahua fenjiahua@qq.com
 * @Date: 2025-03-17 14:21:38
 * @LastEditors: fengjiahua fenjiahua@qq.com
 * @LastEditTime: 2025-10-10 16:37:26
 * @FilePath: \qctsw-vue\packages\app\src\pages\list\hooks\redBlack.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { getCurrentTime } from '@qctsw/utils'
import { logicRedBlackDayList, logicRedBlackWeekList, logicRedBlackWeekYears } from '@/logic/common/redBlack'
import { useGetRouteQuery } from '@/shared/function'
import type { DayRedBlackResponse, RedBlackResponse } from '~/server/types'
import { callWithNuxt } from '#app'
import { RED_BLACK_SITE_META } from '~/shared/site'

export function useRedBlackWeekPage() {
  const type = useGetRouteQuery<'week' | 'day'>('type', 'week')
  const page = useGetRouteQuery('page', '1')

  useSite(RED_BLACK_SITE_META)

  const {
    currentYear,
    yearOptions,
    getYearList,
  } = logicRedBlackWeekYears()

  const {
    list: weekList,
    pagination: weekPagination,
    state: weekState,
    getPage: weekGetPage,
  } = logicRedBlackWeekList()

  const {
    list: dayList,
    pagination: dayPagination,
    state: dayState,
    getPage: dayGetPage,
  } = logicRedBlackDayList()

  const nuxtApp = useNuxtApp()
  async function initHandler() {
    if (type.value === 'week') {
      await getYearList()
      await callWithNuxt(nuxtApp, weekGetPage, [page.value, { year: currentYear.value }])
    }
    else {
      await dayGetPage(page.value)
    }
  }

  const list = computed({
    get() {
      return type.value === 'week' ? weekList.value : dayList.value
    },
    set(val) {
      if (type.value === 'week')
        weekList.value = val as RedBlackResponse[]
      else
        dayList.value = val as DayRedBlackResponse[]
    },
  })
  const pagination = computed(() => type.value === 'week' ? weekPagination : dayPagination)
  const state = computed(() => type.value === 'week' ? weekState.value : dayState.value)

  useActivatedWatch(() => [
    watch([type, currentYear, page], async (nv, ov) => {
      if (nv[0] !== ov[0] || (nv[1] !== ov[1])) {
        if (type.value === 'week')
          weekList.value = []
        else
          dayList.value = []

        pagination.value.initPagination()
      }
      if (JSON.stringify(nv) === JSON.stringify(ov))
        return

      window.scrollTo(0, 0)
      if (nv[0] === 'week') {
        nv[0] !== ov[0] && await getYearList()
        weekGetPage(page.value, { year: (currentYear.value || getCurrentTime('YYYY')) as string })
      }
      else {
        dayGetPage(page.value)
      }
    }),
  ])

  function getMore() {
    // console.log('🚀 ~ getMore ~ pagination.value.pagination.page:', pagination.value.pagination.page)
    const pageNum = pagination.value.pagination.page + 1

    if (type.value === 'week')
      weekGetPage(pageNum, { year: (currentYear.value || getCurrentTime('YYYY')) as string })

    else
      dayGetPage(pageNum)
  }
  return {
    type,
    page,

    currentYear,
    yearOptions,
    getMore,
    list,
    pagination,
    state,
    dayState,
    weekState,
    initHandler,
    weekPagination,
    dayPagination,
  }
}
